import { useMemo, useState } from "react";
import { useFetch } from "../../core/hooks/useFetch"
import { ApiFactory } from "../../core/config/ApiFactory";

export const useFetchProgramasFidelidade = () => {
    const apiEstabelecimento = useMemo(() => ApiFactory.getApi("MS_ESTABELECIMENTOS"), []);
    const baseUrl = `/programas-fidelidade`;
    const [ativo, setAtivo] = useState<boolean | undefined>(true);
    const [url, setUrl] = useState(`${baseUrl}?ativo=true`);

    const handleAtivoChange = (value: boolean | undefined) => setAtivo(value);

    const buildUrl = (ativoValue: boolean | undefined) => {
        const params: string[] = [];
        if (ativoValue !== undefined) {
            params.push(`ativo=${ativoValue}`);
        }
        return params.length > 0 ? `${baseUrl}?${params.join('&')}` : baseUrl;
    };

    const handleLimpar = () => {
        setAtivo(true);
        setUrl(`${baseUrl}?ativo=true`);
    }

    const handleFiltrar = () => {
        setUrl(buildUrl(ativo));
    }
    
    const { data: dados, isLoading, handleRefresh } = useFetch(apiEstabelecimento, url);
    
    return { 
        dados, 
        isLoading, 
        handleRefresh, 
        handleAtivoChange,
        handleLimpar,
        handleFiltrar,
        ativo
    }
}

